import { render, staticRenderFns } from "./big_package.vue?vue&type=template&id=a147866a&"
import script from "./big_package.vue?vue&type=script&lang=js&"
export * from "./big_package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports